import { Reveal, Overline } from "@/components/Reveal";
import { Check } from "@phosphor-icons/react";
import Globe3D from "@/components/marketing/Globe3D";

const WHY_US = [
  ["Experienced team", "Seasoned patent agents, technical analysts and IP attorneys."],
  ["Full domain coverage", "Every technology domain, and every form of IP."],
  ["End-to-end support", "From search & analytics to grant, renewal and enforcement."],
  ["Job-work support", "Dedicated outsourced assistance for law firms and IP teams."],
  ["Client commitment", "Timely delivery, strict confidentiality, clear communication."],
];

export default function GlobalReach() {
  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <Globe3D />
        </Reveal>
        <div>
          <Reveal>
            <Overline>About Claimspace</Overline>
            <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl leading-tight mb-8">
              A single window for <span className="italic text-gold">every IP right.</span>
            </h2>
            <p className="text-mist leading-relaxed mb-6 max-w-lg">
              Founded by <span className="text-white">Anita Patel</span> and <span className="text-white">Akash Yadav</span>,
              ClaimSpace LegalTech Pvt Ltd is a full-service Intellectual Property Rights firm.
              Our patent agents, technical analysts, IP attorneys and drafting specialists work
              with innovators, R&amp;D teams, startups, law firms and corporates — in India and,
              through PCT and national-phase routes, worldwide.
            </p>
          </Reveal>
          <div className="flex flex-col gap-5 mt-10">
            {WHY_US.map(([title, body], i) => (
              <Reveal key={title} delay={i * 0.06}>
                <div className="flex items-start gap-4 border-t border-gold/20 pt-5">
                  <Check size={18} weight="bold" className="text-gold mt-1 shrink-0" />
                  <div>
                    <p className="text-white font-medium">{title}</p>
                    <p className="text-sm text-mist mt-1">{body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
